import { combineEpics, Epic, ofType } from 'redux-observable'
import { catchError, map, mergeMap, of, takeUntil } from 'rxjs'
import { getHub } from '../../helpers/hub'
import { createInvokeEpic } from '../../signalr/createInvokeEpic'
import { logError } from '../ws/actions'
import { receiveHeartbeat } from './actions'
import { heartbeatDefinition } from './definition'

const beginHeartbeatingEpic: Epic = (action$) =>
  action$.pipe(
    ofType('heartbeat.BeginHeartbeating'),
    mergeMap(() => {
      return getHub()
        .stream('Heartbeat')
        .pipe(
          map(receiveHeartbeat),
          catchError((err) => of(logError(err)))
        )
    }),
    takeUntil(action$.pipe(ofType('ws.force-reload', 'auth.redirect-to-login')))
  )

export default combineEpics(
  beginHeartbeatingEpic,
  createInvokeEpic('heartbeat.HeartbeatReceived', heartbeatDefinition)
)
